const check = matchers =>
  matchers
    .reduce((acc, currentRule) => {
      const itMatches = currentRule
        .map(({ match, rules = [] }) =>
          match.some(userMatch => rules.includes(userMatch))
        )
        .every(matches => matches);

      return [...acc, itMatches];
    }, [])
    .some(match => match);

export default check;
